<template>
  <strong @mouseenter="$emit('e')" @mouseleave="$emit('l')"
    ><span v-show="r" class="bullet" :class="c === h ? 'bullet--high' : ''">{{
      h
    }}</span
    >&thinsp;<slot></slot>&thinsp;<span
      v-show="!r"
      class="bullet"
      :class="c === h ? 'bullet--high' : ''"
      >{{ h }}</span
    ></strong
  >
</template>
<script>
export default {
  name: "highlight",
  props: {
    h: {},
    c: {},
    r: {}
  }
};
</script>
